// extracted by mini-css-extract-plugin
export default {"postsContainer":"Makett_postsContainer__fqH-t"};